import { render } from "./TabPane.vue?vue&type=template&id=3ede8dac"
import script from "./TabPane.vue?vue&type=script&lang=js"
export * from "./TabPane.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qinzilie/INFURA-UI/infura-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__